// const defaultFormData = {
//   shopId: '', // 店铺Id
//   visitMode: '', // 1,2,3,4,5 拜访方式
//   // 提交时，合并到visitTime字段上
//   visitTime: '', // 拜访时间
//   // VisitDate: '', // 拜访日期(计划)
//   visitObject: {
//     roleId: 0,
//     name: '',
//     phone: '',
//     contactTime: '',
//     contactMode: []
//   },
//   visitResult: [],
//   // visitPurpose: [],
//   padInfo: {},
//   shopBussinessInfo: {},

//   visitContent: '', // 备注
//   shopPics: [], // 拜访图片
//   lat: 0,
//   lng: 0,
//   // ------------ 商家经营信息 ------------
//   visitShopAttr: { // 商家经营信息是否填写完成（有则表示已经填写过，为空则表示未填写过）
//     shopDevice: [], // 商家设备
//     menuReadability: '', // 菜单是否易读
//     isDarkKitchen: '', // 是否黑暗厨房
//     platformInfo: [],
//     isHasOtherStore: {
//       id: 0, // 否
//       isSameLegalPerson: '',
//       storeNum: '',
//       cooperateNum: ''
//     },
//     areaMainOpportunity: []
//   }
// }
import { get } from 'lodash-es'
import * as api from '@/api'
import dayjs from 'dayjs'

const state = {
  initialData: {},
  businessConfig: {},
  bizoppInfo: {},
  detailInfo: {},
  visitTask: {},
  isVisitTask: true,
  visitTaskData: {},
  visitPlanData: {},
  newVisitActiveTab: 0,
  myVisitPopupStatus: false,
  newVisitDate: dayjs().format('YYYY-MM-DD'),
  curVisitPlanData: {}, // 新增
  roleType: null,
  checkinLogList: [],
  visitResultEnum: [],
  visitResultValid: false,
  visitVersion: null,
  visitBrand: {},
  brandName: '',
}
const getters = {}
const mutations = {
  setInitialData(state, payload) {
    state.initialData = payload
  },
  setBusinessConfig(state, payload) {
    state.businessConfig = payload
  },
  setBizoppInfo(state, payload) {
    state.bizoppInfo = payload
  },
  setDetailInfo(state, payload) {
    state.detailInfo = payload
  },
  updateNewVisitDate(state, payload) {
    state.newVisitDate = payload
  },
  updateVisitActiveTab(state, payload) {
    state.newVisitActiveTab = payload
  },
  updateVisitTaskData(state, payload) {
    state.visitTaskData = payload
  },
  updateVisitPlanData(state, payload) {
    state.visitPlanData = payload
  },
  updateVisitTaskLsit(state, payload) {
    state.visitTask = payload
    if (+state.roleType !== 3) {
      if (get(payload, 'noVisitList.length', 0) || get(payload, 'visitedList.length', 0)) {
        state.isVisitTask = true
      } else {
        state.isVisitTask = false
      }
    } else {
      state.isVisitTask = false
    }
  },
  updateMyVisitPopupStatus(state, payload) {
    state.myVisitPopupStatus = payload
  },
  updateCurVisitPlanData(state, payload) {
    state.curVisitPlanData = payload
  },
  updateRoleType(state, payload) {
    state.roleType = payload
  },
  updateCheckinLogList(state, payload) {
    state.checkinLogList = payload
  },
  updateVisitResultEnum(state, payload) {
    state.visitResultEnum = payload
  },
  updateVisitResultValid(state, payload) {
    state.visitResultValid = payload
  },
  updateVisitVersion(state, payload) {
    state.visitVersion = payload
  },
  updateVisitBrand(state, payload) {
    state.visitBrand = payload
  },
  updateBrandName(state, payload) {
    state.brandName = payload
  },
}
const actions = {
  setInitialData({ commit }, params = {}) {
    commit('setInitialData', params)
  },
  setBusinessConfig({ commit }, params = {}) {
    commit('setBusinessConfig', params)
  },
  setBizoppInfo({ commit }, params = {}) {
    commit('setBizoppInfo', params)
  },
  async getVisitTaskLsit({ commit, state }, params = {}) {
    try {
      await api.getVisitTaskLsit(params).then(result => {
        // 拜访任务列表数据处理
        get(result, 'noVisitList', []).forEach(item => {
          item.visitPlanState = 0
        })
        get(result, 'visitedList', []).forEach(item => {
          item.visitPlanState = 1
        })
        return commit('updateVisitTaskLsit', result)
      })
    } catch (e) {
      console.error(e)
      return false
    }
  },
  delVisitTaskLsit({ commit, state }, params = {}) {
    const visitTask = state.visitTask || {}
    for (const key in visitTask) {
      const items = visitTask[key] || []
      visitTask[key] = items.filter(item => item.visitId !== params.visitId)
    }
    return commit('updateVisitTaskLsit', visitTask)
  },
  //  新加接口
  async getHomeVisitData({ commit, state }, params = {}) {
    await api.getHomePageVisitData(params).then(result => {
      const { homePageVisitDataItem = {}, visitRoleType } = result
      commit('updateCurVisitPlanData', homePageVisitDataItem)
      commit('updateRoleType', visitRoleType)
    })
  },
  // 获取当日打卡记录
  async getCheckinLog({ commit, state }, params = {}) {
    await api.getTodayCheckinLog(params).then(result => {
      const { list } = result.data
      commit('updateCheckinLogList', list)
    })
  },
}
export default {
  namespaced: true,
  actions,
  state,
  mutations,
  getters,
}
